import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TmmSelection } from "./tmmTypes";

export const samTmmSliceName = "samTmm";

export interface SamTmmState {
  selection: TmmSelection;
}

const initialState: SamTmmState = {
  selection: {
    tmmEntries: [],
  },
};

const samSlice = createSlice({
  name: samTmmSliceName,
  initialState,
  reducers: {
    setTmmSelection(state: SamTmmState, action: PayloadAction<TmmSelection>) {
      state.selection = action.payload;
    },
  },
});

export interface SamTmmRootState {
  [samTmmSliceName]: SamTmmState;
}

export const selectSamTmm = (state: SamTmmRootState) => state[samTmmSliceName];
export const selectSamTmmSelection = (state: SamTmmRootState) => {
  return selectSamTmm(state).selection;
};

export const {
  setTmmSelection,
} = samSlice.actions;
export const samTmmReducer = samSlice.reducer;
